import { render, staticRenderFns } from "./loadmore.vue?vue&type=template&id=20ac1fb4"
import script from "./loadmore.vue?vue&type=script&lang=js"
export * from "./loadmore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports